import React, { FC } from 'react';
import { StorageData, useStorage } from '~Components/Storage';
import Toggle from '~ComponentsImproved/Toggle';
import Heading from '~ComponentsImproved/Typography/Heading';
import { useI18n, useLogger, useStaffCan } from '~Hooks';
import { SettingsBlock } from '~Scenes/Settings-v2';
import { Box } from '~Styles';

const StaffSettings: FC = () => {
  const { i18n } = useI18n();
  const [storage, commitToStorage, storageLoading] = useStorage();
  const logger = useLogger('settings-v2');
  const staffCan = useStaffCan();

  function updateStorage(data: Partial<StorageData>) {
    logger.info('Updating Settings (Staff Settings)', { fields: data });

    commitToStorage(data);
  }

  const update = (data: Partial<StorageData>) => {
    logger.info('Updating Settings (Staff Settings)', { fields: { data } });

    updateStorage(data);
  };

  const togglesConfig: Array<{
    label: string;
    subLabel?: string;
    key: string;
    storage: any;
    // Will reverse the value of the storage
    inverted?: boolean;
  }> = [
    {
      label: i18n('Settings.DisableStaffTimeout'),
      subLabel: i18n('Settings.DisableStaffTimeout.Text'),
      key: 'disableStaffTimeout',
      storage: storage.disableStaffTimeout,
    },
  ];

  if (staffCan.REPORTS) {
    togglesConfig.push({
      label: i18n('Settings.Reports.AllowStaffReport'),
      subLabel: i18n('Settings.Reports.AllowStaffReport.SubLabel'),
      key: 'staffCanViewOwnReport',
      storage: storage.staffCanViewOwnReport,
    });
  }

  if (staffCan.REPORTS) {
    togglesConfig.push({
      label: i18n('Settings.Reports.CategoryBreakdown'),
      subLabel: i18n('Settings.Reports.CategoryBreakdown.SubLabel'),
      key: 'showDetailedSalesBreakdown',
      storage: storage.showDetailedSalesBreakdown,
    });
  }

  if (storageLoading) {
    return null;
  }

  return (
    <Box padding="large">
      <Box>
        <Heading level={4} bottom={8} color="var(--colorWhite)">
          {i18n('Settings.Title')}
        </Heading>
      </Box>
      <SettingsBlock>
        {togglesConfig.map((toggle) => (
          <Toggle
            key={toggle.key}
            settingKey={toggle.key}
            label={`${toggle.label} ${storage.devMode ? '[' + toggle.key + ']' : ''} `}
            description={toggle.subLabel}
            initialValue={toggle.inverted ? !toggle.storage : toggle.storage}
            onToggle={() => update({ [toggle.key]: !toggle.storage })}
            fullWidth
            darkBackground
            lightText
          />
        ))}
      </SettingsBlock>
    </Box>
  );
};

export default StaffSettings;
